import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule, TabsModule } from 'ngx-bootstrap';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../../../shared/shared/shared.module';
import { UserAddUserModalComponent } from './user-add-user-modal.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    TabsModule.forRoot(),
    ModalModule.forRoot(),
  ],
  declarations: [UserAddUserModalComponent],
  exports: [UserAddUserModalComponent]
})
export class UserAddUserModalModule {
}
